import { render, staticRenderFns } from "./PartOfSpeech.vue?vue&type=template&id=35bad01f&scoped=true"
import script from "./PartOfSpeech.vue?vue&type=script&lang=ts"
export * from "./PartOfSpeech.vue?vue&type=script&lang=ts"
import style0 from "./PartOfSpeech.vue?vue&type=style&index=0&id=35bad01f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bad01f",
  null
  
)

export default component.exports